import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchUnsyncedCompanyList } from '../actions/companyActions'

const useFetchingCompanyDetails = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchUnsyncedCompanyList())
  }, [dispatch])
}

export default useFetchingCompanyDetails
